module.exports = __webpack_public_path__ + "img/percent2.9fca2fd9.svg";